module.exports = __webpack_public_path__ + "img/picture-3.53c0fa26.png";